import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { getToken, storeAccessToken, storeCustomerID, storeLeadID } from "../utils/storage";
import api from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { addAccountId, addLeadType, addRepeatCustomer, addUserInfo, addUserName, changeLoanApproved, setLeadStatus } from "../redux/slices/userSlice";
import { useEffect } from "react";
// import { utmSourceStorage } from "../lib/script";
import { handleApiStart, handleApiSuccess, handleApiError } from "../utils/contextualLoaderTrigger";
import { consumeUserGesture } from "../utils/userGesture";

function useResponse() {
  const navigate = useNavigate();

  const { isLoanApproved, accountId } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const token = getToken();
  const location = useLocation();

  const handleStep = async (newAccountId) => {
    // const updatedAccountID = newAccountId || "";
    const updatedAccountID = newAccountId || accountId;
    const endpoint = "/step/next-step";
    try {
      handleApiStart(endpoint, consumeUserGesture());
      const req = {
        leadID: Number(localStorage.getItem("leadID")),
        accountID: updatedAccountID,
      };

      const { data } = await api.post(endpoint, req);

      // console.log("Step Data------------", data);

      if (data.statusCode === 200) {
        const existStep = data?.data?.step;

        dispatch(addAccountId(updatedAccountID));

        // storeAccessToken(data?.data?.accessToken);
        storeCustomerID(data?.data?.customer?.customerID);

        dispatch(addUserName(data?.data?.customer?.name));
        dispatch(addUserInfo(data?.data?.customer));
        dispatch(setLeadStatus(data?.data?.status));
        if (existStep) {
          const { current_route } = data?.data?.step;

          if (data?.data?.leadID) {
            storeLeadID(data.data.leadID);
            dispatch(addLeadType(data?.data?.leadType));
          }

          const status =
            data?.data?.status === "Closed" ||
            data?.data?.status === "Bank Update Rejected" ||
            data?.data?.status === "Rejected" ||
            data?.data?.status === "Not Required" ||
            data?.data?.status === "Not Interested" ||
            data?.data?.status === "Rejected Process" ||
            data?.data?.status === "Not Required Process" ||
            data?.data?.status === "Not Eligible";

          if (status && data?.data?.leadType === "Repeat Case") {
            dispatch(addRepeatCustomer(true));
          }

          if (data && data?.data?.status === "Approved Process" && isLoanApproved === false) {
            dispatch(changeLoanApproved(true));
            navigate("/select-loan");
            return;
          }

          setTimeout(() => {
            handleApiSuccess(endpoint);
            navigate(current_route);
          }, 100);
        } else {
          handleApiSuccess(endpoint);
          navigate("/dashboard");
        }
      } else {
        handleApiError(endpoint);
        Swal.fire({
          icon: "error",
          text: data?.message,
        });
      }
    } catch (error) {
      handleApiError(endpoint, error);
      return error?.response?.data;
    }
  };

  return { handleStep, token, location };
}

export default useResponse;
